import { API_PATHS } from "../constants/api-paths";
import { FPR_DATA_STORAGE_KEY } from "../constants/fpr";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { logErrorToNewRelic } from "../utils/logging";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { getCustomerDemogFromApp } from "@repo/shared-utils/common-utils";
import { IResponse, encryptedRequest } from "../core/api.client";
import { ISubscriptionDetailsResponse } from "./fprSubscription.service";
import { IVerifyDetailsResponse } from "./verifyDetails.service";

interface IPaymentStatusParams {
  paymentPodRes: string;
  csRequestId: number;
}

export const getPaymentStatus = async (
  params: IPaymentStatusParams
): Promise<IResponse<ISubscriptionDetailsResponse | IVerifyDetailsResponse> | null> => {
  const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
  const mobileNo = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
  try {
    const response = await encryptedRequest<ISubscriptionDetailsResponse | IVerifyDetailsResponse>({
      method: "POST",
      url: API_PATHS.fprPaymentStatus,
      data: {
        csRequestId: params.csRequestId,
        mobileNo: mobileNo || getCustomerDemogFromApp().mobileNo,
        paymentPodRes: params.paymentPodRes,
      },
      storeResponseInLocal: true,
      storageKey: FPR_DATA_STORAGE_KEY,
    });
    return response;
  } catch (error) {
    logErrorToNewRelic(error as Error, {
      message: "Error in payment status API",
      mobileNo,
    });
    return null;
  }
};
